import cn from 'clsx'
import * as React from 'react'
import enhanceWithClickOutside from 'react-click-outside'

class PopupContainer extends React.Component<{
  children: React.ReactNode
  onHide: (...args: Array<any>) => any
  popupStyle?: string
}> {
  render() {
    return (
      <div
        className={cn(
          'rich-text-toolbar__button__config',
          this.props.popupStyle,
        )}
      >
        {this.props.children}
      </div>
    )
  }

  // `handleClickOutside` is called from react-click-outside HOC
  handleClickOutside = evt => {
    let target = evt.target

    while (target) {
      if (
        target.className &&
        typeof target.className === 'string' &&
        target.className.includes('twitter-picker')
      ) {
        return // click on nested modal - don't hide
      }

      target = target.parentNode
    }

    evt.preventDefault()
    evt.stopPropagation()
    this.props.onHide()
  }
}

export default enhanceWithClickOutside(PopupContainer) as any
